import DialogWrap from './DialogWrap';
export default DialogWrap;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-dialog/es/index.js
// module id = 464
// module chunks = 0